module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Settings.c8ca2477.svg";